import MailFooter            from "../../../../domain/mail/setting/MailFooter";
import MailReplyTo              from "../../../../domain/mail/setting/MailReplyTo";
import MailSetting           from "../../../../domain/mail/setting/MailSetting";
import MailSettingRepository from "../../../../domain/mail/setting/MailSettingRepository";
import { ApiClient }         from "../../../configure/ApiClientConfig";
import {
  setMailSettingAction,
  setMailSettingFooterAction,
  setMailSettingReplyToAction
}                            from "../../../redux/mail/setting/MailSettingAction";

class MailSettingDataSource implements MailSettingRepository {
  constructor(private readonly dispatch) {
  }

  findBy() {
    return ApiClient.get("/mail/setting");
  }

  register(mailSetting: MailSetting) {
    return ApiClient.post("/mail/setting", {
      replyTo: mailSetting.replyTo.value,
      footer: mailSetting.footer.value,
    });
  }

  update(mailSetting: MailSetting) {
    return ApiClient.put("/mail/setting", {
      replyTo: mailSetting.replyTo.value,
      footer: mailSetting.footer.value,
    });
  }

  setMailSetting(mailSetting: MailSetting) {
    this.dispatch(setMailSettingAction(mailSetting));
  }

  setMailSettingReplyTo(mailReplyTo: MailReplyTo) {
    this.dispatch(setMailSettingReplyToAction(mailReplyTo));
  }

  setMailSettingFooter(mailFooter: MailFooter) {
    this.dispatch(setMailSettingFooterAction(mailFooter));
  }
}

export default MailSettingDataSource;
